import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-link-expire',
  templateUrl: './link-expire.component.html',
  styleUrls: ['./link-expire.component.scss']
})
export class LinkExpireComponent implements OnInit {

  msg:any;
  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    
    
       this.msg = localStorage.getItem('msg')
  }

}
